import {
  BarsOutlined,
  CloudUploadOutlined,
  CopyOutlined,
  DatabaseOutlined,
  HomeOutlined,
  InboxOutlined,
  LoginOutlined,
  LogoutOutlined,
  NumberOutlined,
  OrderedListOutlined,
  SearchOutlined,
  SwitcherOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
  home: {
    key: "home",
    slug: "home",
    to: "/home",
    title: "Clasificaciones",
    icon: <OrderedListOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  profile: {
    key: "profile",
    slug: "profile",
    to: "/profile",
    title: "Perfil",
    icon: <UserOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  users: {
    key: "users",
    slug: "users",
    to: "/users",
    title: "Usuarios",
    icon: <UserOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  login: {
    key: "login",
    slug: "login",
    to: "/login",
    title: "LOGIN",
    icon: <LoginOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  deckTypes: {
    key: "deckTypes",
    slug: "deckTypes",
    to: "/deckTypes",
    title: "Arquetipos",
    icon: <SwitcherOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  seasons: {
    key: "seasons",
    slug: "seasons",
    to: "/seasons",
    title: "Temporadas",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  players: {
    key: "players",
    slug: "players",
    to: "/players",
    title: "Jugadores",
    icon: <TeamOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  specialdays: {
    key: "specialdays",
    slug: "specialdays",
    to: "/specialdays",
    title: "Especiales",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  forfundays: {
    key: "forfundays",
    slug: "forfundays",
    to: "/forfundays",
    title: "JornadaForfuns",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  decks: {
    key: "decks",
    slug: "decks",
    to: "/decks",
    title: "Decks",
    icon: <InboxOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  deckPlayeds: {
    key: "deckPlayeds",
    slug: "deckPlayeds",
    to: "/deckPlayeds",
    title: "Decks Jugados",
    icon: <DatabaseOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  uploadeddecks: {
    key: "uploadeddecks",
    slug: "uploadeddecks",
    to: "/uploadeddecks",
    title: "Decks Subidos",
    icon: <CloudUploadOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  days: {
    key: "days",
    slug: "days",
    to: "/days",
    title: "Jornadas",
    icon: <HomeOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  rounds: {
    key: "rounds",
    slug: "rounds",
    to: "/rounds",
    title: "Rondas",
    icon: <HomeOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  games: {
    key: "games",
    slug: "games",
    to: "/games",
    title: "Partidas",
    icon: <NumberOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  newDay: {
    key: "newDay",
    slug: "newDay",
    to: "/newDay",
    title: "Nueva jornada",
    icon: <NumberOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  putDecks: {
    key: "putDecks",
    slug: "putDecks",
    to: "/putDecks",
    title: "Registrar mazos (jornada)",
    icon: <InboxOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  stats: {
    key: "stats",
    slug: "stats",
    to: "/stats",
    title: "Estadísticas",
    icon: <BarsOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  cardSearcher: {
    key: "cardSearcher",
    slug: "cardSearcher",
    to: "/cardSearcher",
    title: "Buscador de Cartas",
    icon: <SearchOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
  placards: {
    key: "placards",
    slug: "placards",
    to: "/placards",
    title: "Carteles",
    icon: <CopyOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  matriz: {
    key: "matriz",
    slug: "matriz",
    to: "/matriz",
    title: "Matriz de Enfrentamientos",
    icon: <BarsOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
  logout: {
    key: "logout",
    slug: "logout",
    to: "/logout",
    title: "Log out",
    icon: <LogoutOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
  top8: {
    key: "top8",
    slug: "top8",
    to: "/top8",
    title: "TOP 8 Bracket",
    icon: <OrderedListOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
  clasificatorio: {
    key: "clasificatorio",
    slug: "clasificatorio",
    to: "/clasificatorio",
    title: "Clasificatorio",
    icon: <BarsOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
  forfunparalel: {
    key: "forfunparalel",
    slug: "forfunparalel",
    to: "/forfunparalel",
    title: "Paralelo ForFun",
    icon: <BarsOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
};
